const shortClientVersion = `${VERSION_MAJOR}.${VERSION_MINOR}`
export const fullClientVersion = BUILD_NUMBER
  ? `${shortClientVersion}.${BUILD_NUMBER}`
  : shortClientVersion
